import get from 'lodash.get';
import queryString from 'qs';

import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import * as SellerActions from '../../../store/seller/seller.actions';
import * as ShipmentActions from '../../../store/shipments/shipments.actions';
import * as ShipmentNavActions from '../../../store/shipments/nav/shipments.nav.actions';
import { GridConfigStateService } from '../../../services/grid-config-state-service';
import { GridConfigUserSettingService } from '../../../services/grid-config-user-setting-service';
import { calculatePagingStats, getNewStateFromPagingData } from '../../../services/pagination-service';
import { UserSettings } from '../../../enums/user-settings/user-settings';
import { getParsedIntValueOrDefault } from '../../../hooks/use-user-setting';

import * as Actions from './shipments.grid.actions';
import { APP_INITIALIZATION } from '../../core/base-actions';

const query = queryString.parse(window.location.search);
const filteredQuery =
  window.location.pathname.includes('shipments') && !window.location.pathname.includes('shipments/returns') ? query : emptyObject;
const initialPagingStats = calculatePagingStats(filteredQuery.page, filteredQuery.pageSize);

const initalState = {
  customViewColumnConfiguration: undefined,
  userViewConfigurations: emptyObject,
  shipments: emptyArray,
  ...initialPagingStats,
  isLoading: false,
  amazonShipmentUpdates: {},
};

const getShipmentsSuccess = (state, action) => {
  const { page, pageSize, totalCount, currentPageFulfillmentIds } = action;
  const pagingStats = calculatePagingStats(page, pageSize, totalCount);
  return {
    ...state,
    isLoading: false,
    ...pagingStats,
    currentPageFulfillmentIds,
  };
};

const getUserSettingsState = (state, action) => {
  const { data } = action;
  const userSettings = get(data, 'userSettings', emptyArray);
  const storedViewConfigsSettings = userSettings.filter((setting) => setting.settingName.includes('v3.shipments.gridConfig'));
  const pageSizeUserSetting = userSettings.find((setting) => setting.settingName === UserSettings.shipmentsGridPageSize.settingName);
  const pageSize = getParsedIntValueOrDefault(pageSizeUserSetting?.settingValue, undefined);

  return {
    ...state,
    userViewConfigurations: storedViewConfigsSettings
      ? GridConfigUserSettingService.buildUserGridConfigMap(storedViewConfigsSettings)
      : emptyObject,
    pageSize: !filteredQuery.pageSize && pageSize ? pageSize : state.pageSize,
  };
};

const patchAmazonShipmentNotifications = (state, action) => {
  const { updatedFulfillments } = action;
  const amazonUpdates = {};
  Object.keys(updatedFulfillments).forEach((fulfillmentId) => {
    amazonUpdates[fulfillmentId] = {
      ...state.amazonShipmentUpdates[fulfillmentId],
      ...updatedFulfillments[fulfillmentId],
    };
  });
  return {
    ...state,
    amazonShipmentUpdates: {
      ...state.amazonShipmentUpdates,
      ...amazonUpdates,
    },
  };
};

export const shipmentsGrid = (state = initalState, action) => {
  const { newPage, pageSize } = action;
  switch (action.type) {
    case Actions.SHIPMENT_GRID_CHANGE_COLUMNS:
    case Actions.SHIPMENT_GRID_CHANGE_ORDERBY: {
      const { statusViewId, filterViewId, columns } = action;
      if (filterViewId === 'custom') {
        return {
          ...state,
          customViewColumnConfiguration: columns,
        };
      }
      return GridConfigStateService.updateStateViewConfig(state, statusViewId, filterViewId, columns);
    }
    case Actions.SHIPMENT_GRID_UPDATE_CUSTOM_CONFIGURATION:
      return {
        ...state,
        customViewColumnConfiguration: action.customViewColumnConfiguration,
      };
    case Actions.SHIPMENT_GRID_CHANGE_PAGE:
      return getNewStateFromPagingData(state, newPage, pageSize);
    case ShipmentActions.GET_SHIPMENTS_REQUEST:
    case Actions.SHIPMENT_GRID_SHOW_SPINNER:
      return { ...state, isLoading: true };
    case ShipmentActions.GET_SILENT_SHIPMENTS_REQUEST:
      return { ...state, isLoading: false };
    case ShipmentActions.GET_SHIPMENTS_SUCCESS:
      return getShipmentsSuccess(state, action);
    case ShipmentActions.GET_SHIPMENTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        currentPageFulfillmentIds: emptyArray,
        totalRecords: 0,
      };
    case ShipmentNavActions.SHIPMENTS_CHANGE_VIEW:
    case ShipmentNavActions.SHIPMENTS_SEARCH:
      return getNewStateFromPagingData(state, action.goToPageOne ? 1 : state.page);
    case APP_INITIALIZATION:
      return getUserSettingsState(state, { data: action.initialData });
    case SellerActions.GET_SELLER_DATA_SUCCESS:
      return getUserSettingsState(state, action);
    case ShipmentNavActions.SHIPMENTS_SET_SEARCH_PERFORMED:
      return {
        ...state,
        searchTerm: action.searchPerformed ? state.searchTerm : undefined,
      };
    case Actions.PATCH_AMAZON_SHIPMENT_NOTIFICATIONS:
      return patchAmazonShipmentNotifications(state, action);
    default:
      return state;
  }
};

export { namespace } from './shipments.grid.reducer.metadata';
